// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"6eb7ab5cdae61d80a623","245":"68cccf5824dc3114d1c0","452":"0a3fbbdec21c116d0398","453":"9a334b10cdbcace2736b"}[chunkId] + ".js";
};